<app-layout preset="data">
  <app-layout-title>{{ 'SIDENAV.ROOT.users' | translate }}</app-layout-title>

  <app-layout-actions>
    <a routerLink="/root/invite" color="primary" mat-stroked-button>
      <mat-icon mat-list-icon>add</mat-icon>
      <mat-label>{{ 'ADMIN.invite' | translate }}</mat-label>
    </a>
  </app-layout-actions>

  <app-layout-content>
    <div class="row search">
      <app-search #nameFilter [field]="['login', 'fullName']" [localeSearch]="true">
        {{ 'ADMIN.search_users' | translate }}
      </app-search>
      <app-hint>
        <span>{{ 'ADMIN.assign_projects_hint' | translate }}
          <mat-icon color="primary">edit</mat-icon>
        </span>
        <span>{{ 'ADMIN.assign_statuses_hint' | translate }}</span>
      </app-hint>
    </div>
    <app-table [columns]="columns"
      [dataSource]="dataSource"
      [filter]="nameFilter"
      [reloader]="reloader"
      loadingType="all"
      [dataLoadingText]="'ADMIN.loading_users' | translate">

      <ng-container *app-table-header="'login'">{{ 'USER.TABLE.login' | translate }}</ng-container>
      <ng-container *app-table-header="'user'">{{ 'USER.TABLE.user' | translate }}</ng-container>
      <ng-container *app-table-header="'phone'">{{ 'USER.TABLE.phone' | translate }}</ng-container>
      <ng-container *app-table-header="'projects'">{{ 'USER.TABLE.projects' | translate }}</ng-container>
      <ng-container *app-table-header="'registeredAt'">{{ 'USER.TABLE.registered_at' | translate }}</ng-container>
      <ng-container *app-table-header="'isActivated'">{{ 'USER.TABLE.is_activated' | translate }}</ng-container>

      <ng-container *app-table-column="let user, name: 'login'">
        {{user.login}}
      </ng-container>

      <app-heading *app-table-column="let user, name: 'user'"
        [subtitle]="user.email"
        [title]="user.fullName"
        hAlign="center">
      </app-heading>

      <ng-container *app-table-column="let user, name: 'phone'">
        {{user.phone}}
      </ng-container>

      <div *app-table-column="let user, name: 'projects'" class="assigned-projects">
        <app-scrollable-list [count]="user.assignedProjects.length">
          <div class="project-list">
            @for (project of user.assignedProjects; track project) {
              <a routerLink="{{user.id}}/project/{{project.id}}/assigned-statuses"
                >
                <app-project-view [iso]="project.isoCode"
                  [name]="project.name"
                  class="project"
                  [matTooltip]="'ADMIN.assign_statuses_tooltip' | translate">
                </app-project-view>
              </a>
            }
          </div>
        </app-scrollable-list>
        <a routerLink="{{user.id}}/assigned-projects" class="assign-projects" mat-icon-button>
          <mat-icon color="primary" [matTooltip]="'ADMIN.reassign_projects' | translate">edit</mat-icon>
        </a>
      </div>

      <app-date *app-table-column="let user, name: 'registeredAt'"
        [date]="user.registeredAt"
        icon="update">
      </app-date>

      <ng-container *app-table-column="let user, name: 'isActivated'">
        @if (user.isActivated) {
          <button (click)="blockAccount(user.id)" mat-icon-button>
            <mat-icon color="primary" [matTooltip]="'ADMIN.account_active' | translate">done</mat-icon>
          </button>
        }
        @if (!user.isActivated) {
          <button (click)="restoreAccount(user.id)" mat-icon-button>
            <mat-icon color="warn" [matTooltip]="'ADMIN.account_inactive' | translate">block</mat-icon>
          </button>
        }
      </ng-container>

    </app-table>
  </app-layout-content>
</app-layout>
